var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",attrs:{"id":"HomeLoading"}},[_c('div',{staticClass:"box-holder"},[_c('div',{staticClass:"box",class:_vm.mode})]),_c('div',{staticClass:"line-holder",class:_vm.mode},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }